var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollapseLarge = function SvgCollapseLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#646567"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M25 18v1.5H12V18h13Z"
  })));
};
export { SvgCollapseLarge as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTcuNSIgc3Ryb2tlPSIjNjQ2NTY3Ii8+CjxwYXRoIGQ9Ik0yNSAxOEwyNSAxOS41TDEyIDE5LjVMMTIgMThMMjUgMThaIiBmaWxsPSIjMTgxODE4Ii8+Cjwvc3ZnPgo=";